import React, { useEffect, useRef, useState } from "react";
import AccountLoader from "../manageAccount/accountLoader";
import { apiUrl } from "../common/constants";
import { response } from "./response";
import { GetRequest } from "../common/helper";
import Alert from "../pnrEnquiry/common/Alert";

function GuestUsersTerms() {
  const [loader, setLoader] = useState(false);
  const [alert, setAlert] = useState({ show: false, msg: "" });
  const [htmlContent, setHtmlContent] = useState("");
  const [lastModifieOn, setLastModifiedOn] = useState(false);
  const viewableContentRef = useRef(null);

  const handleAlert = (msg = false) => {
    if (msg) {
      setAlert({ show: true, msg });
    } else {
      setAlert({ show: false, msg: "" });
    }
  };

  const getContent = () => {
    setLoader(true);
    let url = `${apiUrl.getGuestUsersTermsContent}`;
    GetRequest(url)
      .then((result) => {
        setLoader(false);
        // result = response;
        // console.info(result.data.content);
        if (result.Success && result.data && result.data.content) {
          setHtmlContent(convertHtmlToJsx(result.data.content));
          if (result.data.lastModifieOn) {
            setLastModifiedOn(result.data.lastModifieOn);
          }
        } else if (result?.data && result.data?.ErrorMessage) {
          setAlert({ show: true, msg: result.data.ErrorMessage });
        } else {
          setAlert({ show: true, msg: "Something went wrong." });
        }
      })
      .catch((err) => {
        console.log("err", err);
        setLoader(false);
        setAlert({ show: true, msg: "Something went wrong." });
      });
  };

  const updateUI = (htmlContent) => {
    const parentElement = viewableContentRef.current;
    if (parentElement) parentElement.innerHTML = htmlContent;
  };

  useEffect(() => {
    updateUI(htmlContent);
  }, [htmlContent]);
  useEffect(() => {
    getContent();
  }, []);

  // Utility function to convert HTML to JSX
  const convertHtmlToJsx = (htmlString) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;

    const convertElement = (element) => {
      if (element.nodeType === Node.ELEMENT_NODE) {
        // Handle specific HTML elements
        switch (element.tagName.toLowerCase()) {
          case "li":
            return (
              <li key={Math.random()} className={element.className}>
                {Array.from(element.childNodes).map(convertElement)}
              </li>
            );
          case "p":
            return (
              <p key={Math.random()} className={element.className}>
                {Array.from(element.childNodes).map(convertElement)}
              </p>
            );
          case "div":
            return (
              <div key={Math.random()} className={element.className}>
                {Array.from(element.childNodes).map(convertElement)}
              </div>
            );
          case "ol":
            return (
              <ol key={Math.random()} className={element.className}>
                {Array.from(element.childNodes).map(convertElement)}
              </ol>
            );
          default:
            return Array.from(element.childNodes).map(convertElement);
        }
      } else if (element.nodeType === Node.TEXT_NODE) {
        return element.textContent;
      }
      return null;
    };

    return htmlString;
  };

  return (
    <>
      {loader && <AccountLoader />}
      {alert.show && (
        <Alert msg={alert.msg} error={true} close={() => handleAlert()} />
      )}
      <div className="body_style">
        <div ref={viewableContentRef} className="viewable_content"></div>
        <div style={{ display: "none" }} id="showNtg">
          {htmlContent}
        </div>
        {lastModifieOn && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 10,
              width: "96%",
              background: "#ffffff",
              padding: "16px 10px 16px 10px",
              height: "60px",
              color: "#444444",
              borderTop: "1px solid lightgrey",
              borderRadius: "0px 0px 10px 10px",
            }}
          >
            Last Updated On {lastModifieOn}
          </div>
        )}
      </div>
    </>
  );
}

export default GuestUsersTerms;
